const BRAND_SETUP_SNAPSHOT_FIELDS = [
  "websiteUrl",
  "socialNetworks",
  "businessName",
  "businessDescription",
  "businessTextStyle",
  "businessVoiceAttributes",
  "businessOffering",
  "businessLookAndFeel",
  "businessValueProposition",
  "businessIdealCustomerProfile",
  "businessBuyerPerson",
  "businessColors",
  "logoUrl",
  "businessProductImages",
  "additionalAssets",
  "businessCompetitors",
  "businessCountry",
  "businessTypography",
  "businessTypographyPreview",
];

const serializeValue = (value) => {
  if (value === null || value === undefined) {
    return "";
  }

  if (typeof value === "object") {
    return JSON.stringify(value);
  }

  return String(value);
};

const areValuesEqual = (currentValue, previousValue) =>
  serializeValue(currentValue) === serializeValue(previousValue);

export const getBrandSetupChangedFields = ({ currentData, previousData }) => {
  const current = currentData || {};
  const previous = previousData || {};

  return BRAND_SETUP_SNAPSHOT_FIELDS.filter(
    (field) => !areValuesEqual(current[field], previous[field])
  );
};

export const hasBrandSetupChanges = ({ currentData, previousData }) =>
  getBrandSetupChangedFields({ currentData, previousData }).length > 0;
